import svgUrl from "ni:svgr;75cojXrHUW9oPuuQJMnxK8irWyE0F3UgOObahbKwLnA";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const SvgSending = props => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M8 14a6 6 0 1 1 6-6h1a7 7 0 1 0-7 7v-1Z" fill="currentColor"><animateTransform attributeName="transform" attributeType="XML" type="rotate" from="0 8 8" to="360 8 8" dur="700ms" repeatCount="indefinite" /></path></svg>;
const Memo = memo(SvgSending);
export { Memo as ReactComponent };